import { API_PATHS } from "../constants/api-paths";
import { request } from "../core/api.client";

export interface IFeatureManagementRequest {
  randomNo: string;
  osType: string;
  inputString: {
    age: number | null;
    appVersion: string;
    channel: string;
    city: string;
    customertype: string;
    deviceDetails: string;
    enviroment: string;
    featureClusterId: string;
    langPreference: string;
    osVersion: string;
    pageTag: string;
    pgId: string;
    pageNo: string;
    platform: string;
    tagDetails: Array<{
      sectionName: string;
      tagId: string[];
    }>;
    userMobileNo: string;
  };
  logData: {
    channel: string;
    product: string;
    process: string;
    processType: string;
    subProcess: string;
    user_id: string;
    apiName: string;
    app_version: string;
  };
}

export interface IFeatureManagementResponse {
  featureList: {
    [key: string]: {
      template: string;
      backgd: string;
      data: Array<{
        featureNameTag: string;
        webLink: string;
        featureDesc: string;
        featureIconLink: string;
        featureTemplate: string;
        webIconLink: string;
        featurename: string;
        featureNavigationLink: string;
        featureDescTag: string;
        featurenavigationlink2: string;
        webLink2: string;
        featureId: string;
        status: string;
      }>;
    };
  };
}

export const getFeatureManagementData = async (
  requestData: Partial<IFeatureManagementRequest>
): Promise<IFeatureManagementResponse> => {
  const response = await request<IFeatureManagementResponse>({
    method: "POST",
    url: API_PATHS.featureManagement,
    data: {
      ...requestData,
      inputString: {
        ...requestData.inputString,
      },
      additionalHeaders: {
        apiVersion: "v3",
      },
    },
  });

  if (response.status !== "success") {
    throw new Error(response.message);
  }

  return response.data;
};
